// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type AiChatSessionQueryVariables = Types.Exact<{
  sessionId: Types.Scalars['ID']['input'];
}>;

export type AiChatSessionQuery = { __typename?: 'Query' } & {
  aiChatSession: Types.Maybe<
    { __typename?: 'AIChatSession' } & Pick<Types.AiChatSession, 'sessionId'> & {
        messages: Array<{ __typename?: 'AIChatMessage' } & Pick<Types.AiChatMessage, 'role' | 'content'>>;
      }
  >;
};

export const AiChatSessionDocument = /*#__PURE__*/ gql`
    query AiChatSession($sessionId: ID!) {
  aiChatSession(sessionId: $sessionId) {
    sessionId
    messages {
      role
      content
    }
  }
}
    `;

/**
 * __useAiChatSessionQuery__
 *
 * To run a query within a React component, call `useAiChatSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiChatSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiChatSessionQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useAiChatSessionQuery(
  baseOptions: Apollo.QueryHookOptions<AiChatSessionQuery, AiChatSessionQueryVariables> &
    ({ variables: AiChatSessionQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AiChatSessionQuery, AiChatSessionQueryVariables>(AiChatSessionDocument, options);
}
export function useAiChatSessionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AiChatSessionQuery, AiChatSessionQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AiChatSessionQuery, AiChatSessionQueryVariables>(AiChatSessionDocument, options);
}
// @ts-expect-error
export function useAiChatSessionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<AiChatSessionQuery, AiChatSessionQueryVariables>,
): Apollo.UseSuspenseQueryResult<AiChatSessionQuery, AiChatSessionQueryVariables>;
export function useAiChatSessionSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AiChatSessionQuery, AiChatSessionQueryVariables>,
): Apollo.UseSuspenseQueryResult<AiChatSessionQuery | undefined, AiChatSessionQueryVariables>;
export function useAiChatSessionSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AiChatSessionQuery, AiChatSessionQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AiChatSessionQuery, AiChatSessionQueryVariables>(AiChatSessionDocument, options);
}
export type AiChatSessionQueryHookResult = ReturnType<typeof useAiChatSessionQuery>;
export type AiChatSessionLazyQueryHookResult = ReturnType<typeof useAiChatSessionLazyQuery>;
export type AiChatSessionSuspenseQueryHookResult = ReturnType<typeof useAiChatSessionSuspenseQuery>;
